<div class="container">
    <div class="blockMovie">
        <a class="btn" [routerLink]="['']">Return List Movies</a>
    </div>
    <div class="blockAddMovie">
        <label for="">Title Movie / Serie</label>
        <div  class="blockInput">
            <input type="text" class="titleMovie" name="titleMovie" id="titleMovie"  [(ngModel)]="titleMovie">
            <div class="blockBtnAddMovie">
                <button class="btn btnAddMovie" (click)="editMovie()"> Edit </button>
            </div>
        </div >
    </div>
</div>